import { jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo } from "react";
import { useConstant } from "../../hooks/hooks/useConstant/useConstant.js";
function generateCardId() {
  return window.crypto.randomUUID();
}
const appLauncherCardContext = createContext({
  cardId: ""
});
function AppLauncherCardContextProvider(props) {
  const { children, disabled, cardId: userCardId } = props;
  const cardId = useConstant(() => userCardId ?? generateCardId());
  const contextValue = useMemo(
    () => ({
      cardId,
      disabled
    }),
    [cardId, disabled]
  );
  return /* @__PURE__ */ jsx(appLauncherCardContext.Provider, { value: contextValue, children });
}
function useAppLauncherCard() {
  return useContext(appLauncherCardContext);
}
export {
  AppLauncherCardContextProvider,
  appLauncherCardContext,
  useAppLauncherCard
};
//# sourceMappingURL=AppLauncherCardContextProvider.js.map
